import {FormControlLabel, Radio} from '@mui/material';

// ----------------------------------------------------------------------
export default function RadioButton({disabled = false, label, value, size = 'medium'}) {
	return (
		<FormControlLabel
			disabled={disabled}
			value={value}
			control={<Radio size={size} />}
			label={label}
		/>
	);
}
